import { SessionType } from 'models/Message';
import { useTranslation } from 'react-i18next';

export default function useClosedChat(session: SessionType) {
  const {
    isClosed: isClosedProp,
    leadWithdrawnInterest,
    isArchivedAfterMerging,
    isExternalCommunication,
  } = session || {};

  const { t } = useTranslation();

  const isArchived =
    isClosedProp || leadWithdrawnInterest || isArchivedAfterMerging;

  const forbidMessaging = isArchived || isExternalCommunication;

  const bannerText = !forbidMessaging
    ? ''
    : !isArchived && isExternalCommunication
    ? t('noteFor3rdParty')
    : isArchivedAfterMerging
    ? t('chatArchivedGroupMerging')
    : t('chatArchivedWithdrawn');

  const forbidMessagingText = !forbidMessaging
    ? ''
    : !isArchived && isExternalCommunication
    ? t('forbidMessagingFor3rdParty')
    : isArchivedAfterMerging
    ? t('forbidMessagingChatArchivedGroupMerging')
    : t('forbidMessagingchatArchivedWithdrawn');

  return { isArchived, forbidMessaging, bannerText, forbidMessagingText };
}
